var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLabelPrinted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 6 16 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M22.5 9a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H21v-4H9v4H7.5a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5zM10 24V13h10v11zm2-7h6v-2h-6zm0 5h6v-4h-6zm2-1v-2h3v2z"
})));
export default SvgLabelPrinted;